import React from 'react';
import { useQuery } from '@apollo/client';
import { obtenerWordpressMenu } from '../utilerias/buscadorGeneral';
import { Grid } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import ListaEnlacesMenu from './ListaEnlacesMenu';
import { ListaEnlaceBlog } from './ListaEnlaceBlog';
import Error from '../utilerias/error';
import ArrowRight from '@material-ui/icons/ArrowRight';
import ListaEnScroll from './ListaEnScroll';
import { useState } from "react";

const Index = () => {
  const { error, data } = useQuery(obtenerWordpressMenu, {
    options: { fetchPolicy: "no-cache" },
  });

  function renderSwitch(parametro) {
    switch (parametro) {
      case "Ecosur":
        return { order: 1 };
      case "Investigación":
        return { order: 2 };
      case "Posgrado":
        return { order: 3 };
      case "Vinculación":
        return { order: 4 };
      case "Unidades":
        return { order: 5 };
      case "Servicios":
        return { order: 6 };
      case "Publicaciones":
        return { order: 7 };
      case "Transparencia":
        return { order: 8 };
      case "Protección de Datos Personales":
        return { order: 9 };
      case "Intranet":
        return { order: 10 };
    }
  }

  return (
    <>
      <nav>
        {error && (
          <Error leyenda="Lo sentimos hubo un error al cargar el menu por favor recargar la pagina." />
        )}
        {data &&
          data.menuWP && ( //<PintarMenu key={`${index}-menu`} menu={item} subMenu={item.children} />)
            <ul className="menu-items justify-content-center">
              {data.menuWP.items.map((item, index) => {
                return (
                  <React.Fragment key={`menuItem-${index}`}>
                    {item.title !== "Transparencia" &&
                    item.title !== "Vinculación" &&
                    item.title !== "Intranet" &&
                    item.title !== "Protección de Datos Personales" ? (
                      <li style={renderSwitch(item.title)}>
                        <a
                          href={item.url}
                          className="menu-item ecosur-menu-main"
                        >
                          {item.title}
                        </a>
                        <div className="mega-menu">
                          <div className={"content content-" + item.title}>
                            {(item.title === "Posgrado" ||
                              item.title === "Ecosur") && (
                              <Grid
                                container
                                spacing={4}
                                direction="row"
                                justifyContent="flex-start"
                                alignItems="flex-start"
                              >
                                <Grid
                                  item
                                  xs={6}
                                  sm={3}
                                  className="descripcionPosgrado"
                                  style={{
                                    padding: "0px",
                                    backgroundColor: "#fff",
                                    borderRadius: "5px",
                                  }}
                                >
                                  <ListaEnlaceBlog
                                    key={index}
                                    subItem={item}
                                    itemDescription={item.description}
                                  />
                                </Grid>
                                <Grid
                                  item
                                  xs={6}
                                  sm={9}
                                  className="itemBlog"
                                  style={{ paddingLeft: "30px" }}
                                >
                                  <Grid
                                    container
                                    spacing={4}
                                    direction="row"
                                    justifyContent="flex-start"
                                    alignItems="flex-start"
                                  >
                                    {item.children &&
                                      item.children.map((subItem, index) => {
                                        return (
                                          <React.Fragment
                                            key={`subMenuItem-${index}`}
                                          >
                                            {item.title === "Posgrado" ? (
                                              <Grid
                                                item
                                                xs={6}
                                                sm={3}
                                                className="itemBlog"
                                                style={{ padding: "7px 0px" }}
                                              >
                                                <ListaEnlacesMenu
                                                  key={index}
                                                  subItem={subItem}
                                                />
                                              </Grid>
                                            ) : (
                                              <Grid
                                                item
                                                xs={6}
                                                sm={2}
                                                className="itemBlog"
                                                style={{
                                                  padding: "7px 0px",
                                                  marginRight: "1.6vw",
                                                }}
                                              >
                                                <ListaEnlacesMenu
                                                  key={index}
                                                  subItem={subItem}
                                                />
                                              </Grid>
                                            )}
                                          </React.Fragment>
                                        );
                                      })}
                                  </Grid>
                                </Grid>
                              </Grid>
                            )}

                            {
                              //Menu para i unidades
                              item.title === "Unidades" && (
                                <Grid
                                  container
                                  className="itemUnidades"
                                  spacing={4}
                                  direction="row"
                                  justifyContent="flex-start"
                                  alignItems="flex-start"
                                >
                                  {item.children &&
                                    item.children.map((subItem, index) => (
                                      <Grid
                                        key={`itemBlog-${index}`}
                                        item
                                        xs={6}
                                        sm={2}
                                        className="itemBlog"
                                      >
                                        <ListaEnlaceBlog
                                          key={index}
                                          subItem={subItem}
                                          itemDescription={subItem.description}
                                        />
                                      </Grid>
                                    ))}
                                </Grid>
                              )
                            }
                            {
                              //Menu para publicaicones
                              item.title === "Publicaciones" && (
                                <Grid
                                  container
                                  className="itemPublicaciones"
                                  spacing={5}
                                  direction="row"
                                  justifyContent="flex-start"
                                  alignItems="flex-start"
                                >
                                  {item.children &&
                                    item.children.map((subItem, index) => (
                                      <Grid
                                        key={`itemBlog-${index}`}
                                        item
                                        xs={6}
                                        sm={4}
                                        className="itemPublicaciones"
                                        style={{ padding: "0px 30px" }}
                                      >
                                        <ListaEnlaceBlog
                                          key={index}
                                          subItem={subItem}
                                          itemDescription=""
                                        />
                                      </Grid>
                                    ))}
                                </Grid>
                              )
                            }
                            {
                              //Menu para Serviciso
                              item.title === "Servicios" && (
                                <Grid
                                  container
                                  className="itemServicios"
                                  spacing={5}
                                  direction="row"
                                  justifyContent="center"
                                  alignItems="center"
                                >
                                  {item.children &&
                                    item.children.map((subItem, index) => (
                                      <Grid
                                        key={`itemBlog-${index}`}
                                        item
                                        xs={6}
                                        sm={3}
                                        className="itemBlog"
                                      >
                                        <ListaEnlaceBlog
                                          key={index}
                                          subItem={subItem}
                                          itemDescription=""
                                        />
                                      </Grid>
                                    ))}
                                </Grid>
                              )
                            }
                            {
                              //Menu para investigación
                              item.title === "Investigación" && (
                                <Grid
                                  container
                                  className="itemInvestigacion"
                                  spacing={4}
                                  direction="row"
                                  justifyContent="flex-start"
                                  alignItems="flex-start"
                                >
                                  {item.children && (
                                    <ListaEnScroll item={item} />
                                  )}
                                </Grid>
                              )
                            }
                          </div>
                        </div>
                      </li>
                    ) : (
                      <>
                        {item.title === "Transparencia" ||
                        item.title === "Protección de Datos Personales" ? (
                          <>
                            <li
                              className="dropdown"
                              style={renderSwitch(item.title)}
                            >
                              <a
                                href={item.url}
                                className="menu-item ecosur-menu-main"
                              >
                                {item.title}
                              </a>
                              <ul className="dropdown-menu">
                                {item.children &&
                                  item.children.map((subItem, index) => (
                                    <li key={`dropDownMenu-${index}`}>
                                      <a
                                        href={subItem.url}
                                        className="menu-item"
                                      >
                                        {" "}
                                        <ArrowRight /> {subItem.title}
                                      </a>
                                    </li>
                                  ))}
                              </ul>
                            </li>
                          </>
                        ) : (
                          <>
                            <li style={renderSwitch(item.title)}>
                              {" "}
                              <a
                                href={item.url}
                                style={{ cursor: "pointer" }}
                                className="menu-item ecosur-menu-main"
                              >
                                {item.title}
                              </a>
                            </li>
                          </>
                        )}
                      </>
                    )}
                  </React.Fragment>
                );
              })}
              <li style={{ order: 11 }}>
                <span
                  style={{ cursor: "pointer", color: "#666" }}
                  className="menu-item ecosur-menu-main"
                >
                  <SearchIcon />
                </span>
              </li>
            </ul>
          )}
      </nav>
    </>
  );
};

export default Index;
